"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transfersWithPaginate = exports.copyToClipboard = exports.formatDate = exports.formatHumanDateTime = exports.formatHumanDate = exports.formatAddress = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = require("react");
const formatAddress = (address = "") => address.slice(0, 4) + "..." + address.slice(address.length - 4, address.length);
exports.formatAddress = formatAddress;
const formatHumanDate = (date) => (0, moment_1.default)(date).format("DD MMM, yyyy");
exports.formatHumanDate = formatHumanDate;
const formatHumanDateTime = (date) => (0, moment_1.default)(date).format("MMMM DD, yyyy [at] hh:mm:ss a");
exports.formatHumanDateTime = formatHumanDateTime;
const formatDate = (apiDate) => {
    let date;
    if (apiDate.toString().length < 13) {
        let countDifference = "1" + "0".repeat(13 - apiDate.toString().length);
        date = new Date(apiDate * +countDifference);
    }
    else {
        date = new Date(apiDate);
    }
    const formattedDate = (0, moment_1.default)(new Date(date)).format("DD.MM.YYYY");
    return formattedDate;
};
exports.formatDate = formatDate;
function copyFragment(text) {
    const el = document.createElement("textarea");
    el.value = text;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
}
const copyToClipboard = (text) => {
    copyFragment(text);
};
exports.copyToClipboard = copyToClipboard;
const transfersWithPaginate = (transfers, pageSize) => {
    const [page, setPage] = (0, react_1.useState)(1);
    const [transferForVisible, setTransferForVisible] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        const startIndex = (page - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        setTransferForVisible(transfers.slice(startIndex, endIndex));
    }, [page]);
    const changePage = (e) => {
        setPage(e);
        return e;
    };
    return {
        changePage,
        transferForVisible,
        pageSize,
    };
};
exports.transfersWithPaginate = transfersWithPaginate;
